"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.function.name");

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

var _auth = require("@/utils/auth");

var _vuex = require("vuex");

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var _default = {
  name: 'Upload',
  components: {},
  data: function data() {
    return {
      headers: {
        'Authorization': (0, _auth.getToken)()
      },
      filePaths: [],
      imgUrls: [],
      fileList: []
    };
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['baseApi', 'filesUploadApi'])),
  methods: {
    clearImgs: function clearImgs() {
      this.filePaths = [];
      this.fileList = [];
    },
    setFileList: function setFileList(fileList) {
      this.fileList = fileList;
    },
    handleRemove: function handleRemove(file, fileList) {
      // for (let i = 0; i < this.filePaths.length; i++) {
      //   let o = eval('(' + this.filePaths[i] + ')')
      //   if (o.realName === file.response.realName) {
      //     this.filePaths.splice(i, 1)
      //     break
      //   }
      // }
      // console.log(this.filePaths)
      this.filePaths.splice(0, 1);
      this.$emit('delSuccess', this.filePaths);
    },
    handleSuccess: function handleSuccess(response, file, fileList) {
      // this.filePaths.push(JSON.stringify(response))
      // this.$emit('uploadSuccess', this.filePaths)
      // console.log(this.filePaths)
      this.filePaths.push(JSON.stringify(response)); // let videoUrl = file.response.realName==undefined?JSON.parse(file.response):file.response
      // this.VideoPath = this.baseApi + '/file/' + videoUrl.type + '/' + videoUrl.realName
      // console.log(this.VideoPath)

      this.$emit('uploadSuccess', this.filePaths);
    },
    handlePreview: function handlePreview(file) {
      // var a = document.createElement('a');
      // var event = new MouseEvent('click');
      // a.download = file.name;
      // a.href = file.url;
      // a.dispatchEvent(event);
      var url = file.url;
      var a = document.createElement('a');
      a.slot = "reference";
      a.target = "_blank";
      a.href = url;
      a.download = file.name; // 下载后文件名

      a.style.display = 'none';
      document.body.appendChild(a);
      a.click(); // 点击下载

      document.body.removeChild(a); // 下载完成移除元素
    },
    handleExceed: function handleExceed(files, fileList) {
      this.$message.warning("\u5F53\u524D\u9650\u5236\u4E0A\u4F20 1 \u4E2A\u6587\u4EF6" // 本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    beforeRemove: function beforeRemove(file, fileList) {
      return this.$confirm("\u786E\u5B9A\u79FB\u9664 ".concat(file.name, "\uFF1F"));
    }
  }
};
exports.default = _default;